module.exports = __webpack_public_path__ + "img/outdated-icon.ade02083.png";